import React, { FC, useEffect } from 'react'
import { getQuery } from 'Pages/landings/newLandings/common/helpers'
import { RboPage } from 'Pages/landings/newLandings/products/rboPage'
import { RkoPage } from 'Pages/landings/newLandings/products/rkoPage'
import { MiddlePage } from 'Pages/landings/newLandings/products/middlePage'
import { YA_METRIKA_ID } from 'Pages/landings/newLandings/products/constants'
import { ProductNames } from 'Pages/landings/newLandings/common/constants'

const LandingProducts: FC = () => {
	const product = getQuery()?.product

	useEffect(() => {
		let counter
		let interval
		try {
			interval = setInterval(() => {
				// @ts-ignore
				if (window.Ya !== undefined) {
					// @ts-ignore
					counter = new Ya.Metrika2({
						id: YA_METRIKA_ID,
						clickmap: true,
						trackLinks: true,
						accurateTrackBounce: true,
						trackHash: true,
						ecommerce: 'dataLayer',
					})
					clearInterval(interval)
				}
			}, 250)
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Error Ya.Metrika init: ', error)
		}
		return () => {
			counter?.destruct()
			clearInterval(interval)
		}
	}, [])

	if (product === ProductNames.RBO) return <RboPage />
	if (product === ProductNames.RKO) return <RkoPage />

	return <MiddlePage />
}

export default LandingProducts
